import React from "react";
import { useDrag, useDrop } from "react-dnd";
import styled from "styled-components";

import { EditorAudio } from "@components/EditorComponents/EditorAudio";
import { EditorImage } from "@components/EditorComponents/EditorImage";
import { EditorRunningText } from "@components/EditorComponents/EditorRunningText";
import { EditorStreaming } from "@components/EditorComponents/EditorStreaming";
import { EditorVideo } from "@components/EditorComponents/EditorVideo";
import { EditorWebsite } from "@components/EditorComponents/EditorWebsite";
import { EditorYoutubeLive } from "@components/EditorComponents/EditorYoutubeLive";

const Container = styled.div``;

export const DraggableShowMediaBlock = ({
  item,
  type,
  index,
  mediaListImageKey,
  blockMediaList,
  setBlockMediaList,
  setActiveIndex,
  isActive,
  moveBlock,
  thumbnailPath,
  campaignData,
  mediaListAudioKey,
  mediaListVideoKey,
}) => {
  const [, ref] = useDrag({
    type: "BLOCK",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "BLOCK",
    drop: (draggedItem) => {
      if (draggedItem?.index !== index) {
        moveBlock(draggedItem?.index, index);
        draggedItem.index = index;
      }
    },
  });
  return (
    <Container ref={(node) => ref(drop(node))}>
      {(() => {
        switch (type) {
          case "image":
            return (
              // <div key={key} ref={(node) => ref(drop(node))}>
              <EditorImage
                item={item}
                index={index}
                mediaListImageKey={mediaListImageKey}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
              // </div>
            );
          case "video":
            return (
              <EditorVideo
                item={item}
                index={index}
                mediaListVideoKey={mediaListVideoKey}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                thumbnailPath={thumbnailPath}
              />
            );
          case "audio":
            return (
              <EditorAudio
                item={item}
                index={index}
                mediaListAudioKey={mediaListAudioKey}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
            );

          case "website":
            return (
              <EditorWebsite
                item={item}
                campaignData={campaignData}
                index={index}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
            );
          case "youtube-live":
            return (
              <EditorYoutubeLive
                item={item}
                campaignData={campaignData}
                index={index}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
            );

          case "running-text":
            return (
              <EditorRunningText
                item={item}
                campaignData={campaignData}
                index={index}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
            );

          case "video-streaming":
            return (
              <EditorStreaming
                item={item}
                campaignData={campaignData}
                index={index}
                blockMediaList={blockMediaList}
                setBlockMediaList={setBlockMediaList}
                setActiveIndex={setActiveIndex}
                isActive={isActive}
              />
            );

          default:
            return null;
        }
      })()}
    </Container>
  );
};
